import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Dashheader from '../Dashheader/Dashheader';
import './addcustomer.css';
import api from './../../../api.js';
import { useToasts } from "react-toast-notifications";
import utilis from '../../../utilis';
const AddCustomer = () => {
   const navigate = useNavigate();
    const { addToast } = useToasts();

  // Dropdown options for Source
  const sourceOptions = ["Online", "Referral", "Walk-in", "Event", "Other"];
 const storedData = JSON.parse(localStorage.getItem("AdminDetails")) || {};
  const managementId = storedData?.data?.data?._id || null;
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    birthDate: "",
    gender: "",
    emailId: "",
    phoneNumber: "",
    phoneNumber2: "",
    countryCode: "91",
    countryCode2: "91",
    whatsappNumber: "",
    govtIdProof: "",
    proofType: "",
    houseNo: "",
    street: "",
    city: "",
    state: "",
    pinCode: "",
    source: "",
    occupation: "",
    registeredBy:managementId,
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
  if (name === "salutation") {
  // Always remove any existing salutation
  const currentName = formData.name.replace(/^(Mr|Mrs|Ms)\.\s*/i, "");
  setFormData({
    ...formData,
    name: `${value}. ${currentName}`,
  });
} else if (name === "name") {
      // If name is being changed, keep current salutation if present
      const match = formData.name.match(/^(Mr|Mrs|Ms)\./i);
  const salutation = match ? match[1] : "Mr";
  const cleanedName = value.replace(/^(Mr|Mrs|Ms)\.\s*/i, "");
  setFormData({
    ...formData,
    name: `${salutation}. ${cleanedName}`,
  });
    } else if (name === "state") {
    // Find the selected state object
    const selectedState = customerStates.find((state) => state.name === value);
    setFormData({
      ...formData,
      state: value,
      stateId: selectedState ? selectedState._id : "",
    });
  } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
        console.log("Submitting data to API...");
        const response = await api.addCustomer(formData);

        console.log("Full API Response:", response);
        if(response.status === 401){
          console.log("Session Expired! Redirecting to Login.");
          localStorage.removeItem(utilis.string.localStorage.sessionId);
          localStorage.removeItem(utilis.string.localStorage.userData);
          navigate('/');
        }

        if (response.status === 200) {  // Axios should return `status`
            console.log("API Success - Showing toast...");
            addToast("Customer added successfully!", {
                appearance: "success",
                autoDismiss: true,
            });

            const storedData = JSON.parse(localStorage.getItem("AdminDetails")) || {};
            let managementId = storedData?.data?.data?._id || null;

            setFormData({
                name: "",
                surname: "",
                birthDate: "",
                gender: "",
                emailId: "",
                phoneNumber: "",
                phoneNumber2: "",
                countryCode: "91",
                countryCode2: "91",
                whatsappNumber: "",
                govtIdProof: "",
                proofType: "",
                houseNo: "",
                street: "",
                city: "",
                state: "",
                pinCode: "",
                source: "",
                occupation: "",
                registeredBy: managementId,
            });

        } else {
            console.log("API Error - Showing toast...");
            addToast(response.data?.message || "Something went wrong!", {
                appearance: "error",
                autoDismiss: true,
            });
        }
    } catch (error) {
        console.error("Error:", error);
        addToast("Failed to add customer!", {
            appearance: "error",
            autoDismiss: true,
        });
    } finally {
        setLoading(false);
    }
};

 const [customerStates, setcustomerStates] = useState([]);
 const GetCustomerState = async () => {
    setLoading(true); // Start loading
    try {
      let response = await api.getCustomerState();
      setcustomerStates(response.data.data);
      console.log(response.data.data  ,' customer states');
    } catch (error) {
      console.error("Error fetching projects:", error);
    }finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    GetCustomerState();
  }, []);


  return (
    <>
      <Dashheader />
      <div className="addcustomer">
        <div className="addcustomer-container">
          <h2 className="addcustomer-title">Add Customer</h2>
          <form onSubmit={handleSubmit}>
            <div className="addcustomer-form-group">
              <label>Name *</label>
              <div style={{ display: 'flex', gap: '8px' }}>
                <select
                  name="salutation"
                  value={(() => {
  const match = formData.name.match(/^(Mr|Mrs|Ms)\./i);
  return match ? match[1] : "Mr";
})()}

                  onChange={handleChange}
                  required
                  style={{ width: '80px' }}
                >
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Ms">Ms</option>
                </select>
                <input
                  type="text"
                  name="name"
                  value={formData.name.replace(/^(Mr|Mrs|Ms)\.\s*/i, "")}

                  onChange={handleChange}
                  required
                  style={{ flex: 1 }}
                  placeholder="Enter Name"
                />
              </div>
            </div>

            <div className="addcustomer-form-group">
              <label>Surname *</label>
              <input type="text" name="surname" value={formData.surname} onChange={handleChange} required />
            </div>

            <div className="addcustomer-form-group">
              <label>Birth Date *</label>
              <input type="date" name="birthDate" value={formData.birthDate} onChange={handleChange} required />
            </div>

            <div className="addcustomer-form-group">
              <label>Gender *</label>
              <select name="gender" value={formData.gender} onChange={handleChange} required>
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="addcustomer-form-group">
              <label>Email ID *</label>
              <input type="email" name="emailId" value={formData.emailId} onChange={handleChange} required />
            </div>

            <div className="addcustomer-form-group">
              <label>Phone Number *</label>
              <div className="phone-input">
                <select name="countryCode" value={formData.countryCode} onChange={handleChange}>
                  <option value="91">+91</option>
                  <option value="971">+971</option>
                  <option value="966">+966</option>
                  <option value="1">+1</option>
                  <option value="44">+44</option>
                  <option value="61">+61</option>
                </select>
                <input type="text" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} required />
              </div>
            </div>

            <div className="addcustomer-form-group">
              <label>Alternate Phone Number</label>
              <div className="phone-input">
                <select name="countryCode2" value={formData.countryCode2} onChange={handleChange}>
                  <option value="91">+91</option>
                  <option value="971">+971</option>
                  <option value="966">+966</option>
                  <option value="1">+1</option>
                  <option value="44">+44</option>
                  <option value="61">+61</option>
                </select>
                <input type="text" name="phoneNumber2" value={formData.phoneNumber2} onChange={handleChange} />
              </div>
            </div>

            <div className="addcustomer-form-group">
              <label>WhatsApp Number *</label>
              <input type="text" name="whatsappNumber" value={formData.whatsappNumber} onChange={handleChange} required />
            </div>

            <div className="addcustomer-form-group">
              <label>City *</label>
              <input type="text" name="city" value={formData.city} onChange={handleChange} required />
            </div>

            {/* <div className="addcustomer-form-group">
              <label>State *</label>
              <input type="text" name="state" value={formData.state} onChange={handleChange} required />
            </div> */}

            <div className="addcustomer-form-group">
  <label>State *</label>
  <select
    name="state"
    value={formData.state}
    onChange={handleChange}
    required
  >
    <option value="">Select State</option>
    {customerStates.map((state) => (
      <option key={state._id} value={state.name}>
        {state.name}
      </option>
    ))}
  </select>
</div>

            <div className="addcustomer-form-group">
              <label>Pin Code *</label>
              <input type="text" name="pinCode" value={formData.pinCode} onChange={handleChange} required />
            </div>


            <div className="addcustomer-form-group" style={{ display: 'grid', gridTemplateColumns: 'auto 170px 100px 1fr', gap: '8px', alignItems: 'center', marginBottom: '16px' }}>
              <label style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>Proof Type *</label>
              <select name="proofType" value={formData.proofType || ''} onChange={handleChange} required style={{ width: '100%' }}>
                <option value="">Select Proof Type</option>
                <option value="aadhar card">Aadhar Card</option>
                <option value="pancard">Pan Card</option>
                <option value="license">License</option>
              </select>
              <label style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>Govt ID Proof *</label>
              <input type="text" name="govtIdProof" value={formData.govtIdProof} onChange={handleChange} required style={{ width: '100%' }} />
            </div>

<div className="addcustomer-form-group">
  <label>House No *</label>
  <input type="text" name="houseNo" value={formData.houseNo} onChange={handleChange} required />
</div>

<div className="addcustomer-form-group">
  <label>Street *</label>
  <input type="text" name="street" value={formData.street} onChange={handleChange} required />
</div>

<div className="addcustomer-form-group">
  <label>Source *</label>
  <select name="source" value={formData.source} onChange={handleChange} required>
    <option value="">Select Source</option>
    {sourceOptions.map(option => (
      <option key={option} value={option}>{option}</option>
    ))}
  </select>
</div>

<div className="addcustomer-form-group">
  <label>Occupation *</label>
  <input type="text" name="occupation" value={formData.occupation} onChange={handleChange} required />
</div>


            <button type="submit" className="addcustomer-submit-btn" disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddCustomer;
    